import { render } from "./SpotlightPanel.vue?vue&type=template&id=01b2c515"
import script from "./SpotlightPanel.vue?vue&type=script&lang=js"
export * from "./SpotlightPanel.vue?vue&type=script&lang=js"

import "./SpotlightPanel.vue?vue&type=style&index=0&id=01b2c515&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__